<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <customer-field
          :label="customLabel.sa_custname"
          v-model="form.main.sa_custname"
          @select="onSelectCustomer"
          slot="sa_custname"
        />
        <customer-addr-field
          :label="customLabel.sa_toplace"
          v-model="form.main.sa_toplace"
          @select="onSelectCustomer"
          :customer-id="form.main.sa_custid"
          v-if="form.main.sa_custname"
          slot="sa_toplace"
        />
        <customer-ct-field
          slot="sa_contact"
          :label="customLabel.sa_contact"
          v-model="form.main.sa_contact"
          :customer-id="form.main.sa_custid"
          v-if="form.main.sa_custname"
        />
        <div class="weui-cell" slot="sa_tel" v-if="form.main.sa_tel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sa_tel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">{{ form.main.sa_tel }}</div>
        </div>
        <div class="weui-cell" slot="sa_pocode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sa_pocode || "客户PO号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.sa_pocode"
              placeholder="请输入"
            />
          </div>
        </div>
        <payment-field
          :label="customLabel.sa_payments"
          v-model="form.main.sa_payments"
          @select="onSelectPayment"
          slot="sa_payments"
          limit="customer"
          :limit-id="form.main.sa_custid"
        />
        <currency-field
          :label="customLabel.sa_currency || '币种'"
          v-model="form.main.sa_currency"
          @select="onSelectCurrency"
          slot="sa_currency"
        />
        <div class="weui-cell" slot="sa_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sa_taxrate || "税率"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.sa_taxrate"
              @change="calcItem('税率')"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after" slot="sa_class">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sa_class || "销售类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.sa_class"
              placeholder="请选择"
            >
              <option :value="'正常'">正常</option>
              <option :value="'样品'">样品</option>
            </select>
          </div> 
        </div>
        <div class="weui-cell" slot="sa_remark">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.sa_remark || "备注"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.sa_remark"
                placeholder="备注"
              />
            </div>
        </div>
        <employee-field slot="sa_seller" :label="customLabel.sa_seller || '业务员 '"  v-model="form.main.sa_seller"
            @select="onSelectEmployee"/>
        <department-field slot="sa_dpname" :label="customLabel.sa_dpname || '部门 '"
          v-model="form.main.sa_dpname" @select="onSelectDepartment" />    
        <custom-field 
          :label="customLabel.sa_text1 || '自定义字段1'"
          v-model="form.main.sa_text1" :caller="caller" fieldName="sa_text1"
          slot="sa_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.sa_text2 || '自定义字段2'"
          v-model="form.main.sa_text2" :caller="caller" fieldName="sa_text2"
          slot="sa_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.sa_text3 || '自定义字段3'"
          v-model="form.main.sa_text3" :caller="caller" fieldName="sa_text3"
          slot="sa_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.sa_text4 || '自定义字段4'"
          v-model="form.main.sa_text4" :caller="caller" fieldName="sa_text4"
          slot="sa_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.sa_text5 || '自定义字段5'"
          v-model="form.main.sa_text5" :caller="caller" fieldName="sa_text5"
          slot="sa_text5" hidden="true"
        />
        <file-field v-model="form.main.sa_attach" slot="sa_attach" hidden="true" />
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <custom-layout
          class="weui-cells"
          :view-config="customViewConfig"
          position="detail1"
        >
          <div class="weui-cell" slot="sd_custprodcode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.sd_custprodcode || "客户料号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.sd_custprodcode"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sd_prodcode" v-if="item.productDTO.pr_code">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.sd_prodcode || "产品编号"
              }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.productDTO.pr_code }}</div>
          </div>
          <product-field-order slot="pr_detail"
            :label="customLabel.pr_detail || '产品名称'"
            listUrl="/api/sale/quotation/product_list"
            :extraParams="{
              custId: form.main.sa_custid
            }"
            v-model="item.productDTO.pr_detail"
            @select="onSelectProduct($event, item)"
          />
          <div
            class="weui-cell"
            slot="pr_orispeccode"
            :hidden="!item.productDTO.pr_orispeccode"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ item.productDTO.pr_orispeccode }}
            </div>
          </div>
          <div class="weui-cell" slot="pr_spec" :hidden="!item.productDTO.pr_spec">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pr_spec || "规格"
              }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.productDTO.pr_spec }}</div>
          </div>
          <div class="weui-cell" slot="sd_qty">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.sd_qty || "数量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.sd_qty"
                @change="calcItem('数量', item)"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.productDTO.pr_unit }}</div>
          </div>
          <div class="weui-cell" slot="pr_unit_extra" v-if="item.productDTO.pr_unit_extra">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                "辅助数量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                :value="$number.round(item.sd_qty / item.productDTO.pr_denominator * item.productDTO.pr_numerator || 0, 3)"
                @input="oninputQty($event, item)"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.productDTO.pr_unit_extra }}</div>
          </div>
          <div class="weui-cell" slot="sd_netprice" v-if="priceMethod == '1'" :key="xindex + 'sd_netprice'">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.sd_netprice || "不含税单价"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.sd_netprice"
                @change="calcItem('不含税单价', item)"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sd_nettotal" v-if="item.sd_netprice && priceMethod == '1'">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.sd_nettotal || "不含税金额"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ numberFormat(item.sd_nettotal,'¥#,##0.00') }}
            </div>
          </div>
          <div class="weui-cell" slot="sd_price" v-if="priceMethod == '0'" :key="xindex + 'sd_price'">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.sd_price || "含税单价"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.sd_price"
                @change="calcItem('含税单价', item)"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sd_price_extra" v-if="item.productDTO.pr_unit_extra">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                "辅助单价"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                :value="$number.round(item.sd_price / item.productDTO.pr_denominator * item.productDTO.pr_numerator || 0, 3)"
                @input="oninputPriceExtra($event, item)"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" v-if="item.sd_price && priceMethod == '0'" slot="sd_total" :key="xindex + 'sd_total'">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.sd_total || "含税金额"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ numberFormat(item.sd_total,'¥#,##0.00') }}
            </div>
          </div>
          <date-field
            :label="customLabel.sd_delivery || '交货日期'"
            slot="sd_delivery"
            v-model="item.sd_delivery"
          />
          <div class="weui-cell" slot="sd_remark">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.sd_remark || "备注"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.sd_remark"
                placeholder="备注"
              />
            </div>
          </div>
          <custom-field 
            :label="customLabel.sd_text1 || '自定义字段1'"
            v-model="item.sd_text1" :caller="caller" fieldName="sd_text1"
            slot="sd_text1" hidden="true"
          />
          <custom-field
            :label="customLabel.sd_text2 || '自定义字段2'"
            v-model="item.sd_text2" :caller="caller" fieldName="sd_text2"
            slot="sd_text2" hidden="true"
          />
          <custom-field 
            :label="customLabel.sd_text3 || '自定义字段3'"
            v-model="item.sd_text3" :caller="caller" fieldName="sd_text3"
            slot="sd_text3" hidden="true"
          />
          <custom-field 
            :label="customLabel.sd_text4 || '自定义字段4'"
            v-model="item.sd_text4" :caller="caller" fieldName="sd_text4"
            slot="sd_text4" hidden="true"
          />
          <custom-field 
            :label="customLabel.sd_text5 || '自定义字段5'"
            v-model="item.sd_text5" :caller="caller" fieldName="sd_text5"
            slot="sd_text5" hidden="true"
          />
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </custom-layout>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import CustomField from "@/components/field/CustomField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import CustomerAddrField from "@/components/field/CustomerAddrField.vue";
import CustomerCtField from "@/components/field/CustomerCtField.vue";
import PaymentField from "@/components/field/PaymentField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import ProductFieldOrder from "@/components/field/ProductFieldOrder.vue";
import DateField from "@/components/field/DateField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";
import Config from '@/util/config';

export default {
  components: {
    CustomLayout,
    CustomerField,
    CustomField,
    CustomerAddrField,
    CustomerCtField,
    PaymentField,
    CurrencyField,
    ProductFieldOrder,
    DateField,
    DepartmentField,
    EmployeeField,
    FileField
  },
  mixins: [process],
  props: {
    itemData: Object,
  },
  data() {
    return {
      baseUrl: "/api/sale/sale",
      codeField: "sa_code",
      statusField: "sa_statuscode",
      caller: "Sale",
      xtype: "sale-sale-formpanel",
      form: {
        main: {
          sa_custname: null,
          sa_custid: null,
          sa_contact: null,
          sa_toplace: null,
          sa_tel: null,
          sa_pocode: null,
          sa_payments: null,
          sa_currency: null,
          sa_sellerid: null,
          sa_sellercode: null,
          sa_dpid: null,
          sa_dpcode: null,
          sa_dpname: null,
          sa_taxrate: 0
        },
        items: [
          {
            sd_custprodcode: "",
            sd_qty: 0,
            sd_netprice: 0,
            sd_nettotal: 0,
            sd_price: 0,
            sd_total: 0,
            sd_taxamount: 0,
            sd_delivery: "",
            productDTO: {},
          },
        ],
      },
      priceMethod: '0'
    };
  },
  mounted() {
    var me = this;
    Config.getConfigValue('priceMethod').then(v => me.priceMethod = v ? v.data : '0');
    if (this.itemData) {
      let {main, items} = this.form,
        itemData = this.itemData
      main.sa_custname = itemData.sa_custname;
      main.sa_custid = itemData.sa_custid;
      main.sa_contact = itemData.sa_custcontact;
      main.sa_toplace = itemData.sa_toplace;
      main.sa_tel = itemData.sa_custmobile;
      main.sa_pocode = itemData.sa_pocode;
      main.sa_payments = itemData.sa_payments;
      main.sa_currency = itemData.sa_currency;
      main.sa_taxrate = itemData.sa_taxrate;
      main.sa_category = itemData.sa_category;
      main.sourceType = 10;
      if (itemData.orderDetails.length > 0) {
        itemData.orderDetails.forEach((item, index) => {
          if(!items[index]) this.addItem()

          items[index].sd_custprodcode = item.sd_custprodcode;
          items[index].sd_qty = item.sd_qty;
          items[index].sd_netprice = item.sd_costprice;
          items[index].sd_price = item.sd_price;
          items[index].sd_nettotal = item.sd_costprice * item.sd_qty;
          items[index].sd_total = item.sd_total;
          items[index].sd_delivery = item.sd_delivery;
          items[index].sd_taxamount = item.sd_total - item.sd_nettotal;

          items[index].productDTO = item.productDTO || {}
          if(item.productDTO){
            items[index].sd_prodid = item.productDTO.id
            items[index].sd_prodcode = item.productDTO.pr_code
            items[index].pr_orispeccode = item.productDTO.pr_orispeccode
            items[index].pr_spec = item.productDTO.pr_spec
            items[index].pr_detail = item.productDTO.pr_detail
            items[index].pr_brand = item.productDTO.pr_brand
          }else{
            items[index].pr_orispeccode = item.sd_custorispeccode
            items[index].pr_spec = item.sd_custprodspec
            items[index].pr_detail = item.sd_custproddetail
            items[index].pr_brand = item.sd_custprodbrand
          }
        });
      }
    }
  },
  methods: {
    /**
     * 选择客户
     */
    onSelectCustomer(selection) {
      var me = this,
        main = me.form.main;
      main.sa_custid = selection.id;
      main.sa_custcode = selection.cu_code;
      main.sa_toplace = selection.ca_address;
      main.sa_sellercode = selection.cu_sellercode;
      main.sa_seller = selection.cu_sellername;
      main.sa_sellerid = selection.cu_sellerid;
      main.sa_dpcode = selection.cu_dpcode;
      main.sa_dpname= selection.cu_dpname;
      main.sa_dpid = selection.cu_dpid;
      main.sa_currency = selection.cu_currency;
      main.sa_rate = selection.cr_rate;
      main.sa_contact = selection.cc_name;
      main.sa_tel = selection.cc_tel;
      main.sa_paymentsid = selection.cu_paymentsid;
      main.sa_paymentscode = selection.cu_paymentscode;
      main.sa_payments = selection.cu_payments;
      main.sa_taxrate = selection.cu_taxrate;
    },
    /**
     * 选择收款方式
     */
    onSelectPayment(selection) {
      var me = this,
        main = me.form.main;
      main.sa_paymentsid = selection.cp_paid;
      main.sa_paymentscode = selection.cp_pacode;
    },
    /**
     * 选择币种
     */
    onSelectCurrency(selection) {
      var me = this,
        main = me.form.main;
      main.sa_rate = selection.cr_rate;
    },
    /**
     * 选择明细产品
     */
    onSelectProduct(selection, item) {
      item.sd_prodid = selection.id;
      item.sd_prodcode = selection.pr_code;
      item.productDTO = Object.assign({}, selection);

      if(selection.priceList)item.priceList = selection.priceList.reverse()
    },
    onSelectDepartment(selection) {
      var me = this,
      form = me.form,
      main = form.main;
      main.sa_dpid = selection.id;
      main.sa_dpcode = selection.dp_code;
      main.sa_dpname = selection.dp_name;
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.sa_sellerid = selection.id;
      main.sa_sellercode = selection.em_code;
      main.sa_dpid = selection.em_dpid;
      main.sa_dpcode = selection.dp_code;
      main.sa_dpname = selection.dp_name;
    },
    /**
     * 输入辅助数量
     */
    oninputQty(e, item) {
      item.sd_qty = e.target.value / item.productDTO.pr_numerator * item.productDTO.pr_denominator
      this.calcItem("数量", item)
    },
    /**
     * 输入辅助单价
     */
    oninputPriceExtra(e, item) {
      item.sd_price = e.target.value / item.productDTO.pr_numerator * item.productDTO.pr_denominator
      this.calcItem("含税单价", item)
    },
    /**
     * 计算单价、金额
     */
    calcItem(type, selection) {
      var me = this,
        main = me.form.main,
        tr = main.sa_taxrate || 0,
        items = selection ? [selection] : me.form.items;

      items.forEach((item) => {
        item.sd_qty = me.$number.round(item.sd_qty || 0, 3);

        if (type == '数量') {
          let price
          if(item.priceList && item.priceList.length > 0) {
            price = item.priceList.find(e => item.sd_qty >= e.gp_step)
            item.sd_price = me.$number.round(price.gp_price || 0, 6);
          }
          item.sd_total = me.$number.round(item.sd_qty * item.sd_price, 2);
          item.sd_netprice = me.$number.round(item.sd_price / (1 + tr / 100), 6);
          item.sd_nettotal = me.$number.round(item.sd_qty * item.sd_netprice, 2);
        } else if (type == '不含税单价') {
          item.sd_netprice = me.$number.round(item.sd_netprice || 0, 6);
          item.sd_nettotal = me.$number.round(item.sd_qty * item.sd_netprice, 2);
          item.sd_price = me.$number.round(item.sd_netprice * (1 + tr / 100), 6);
          item.sd_total = me.$number.round(item.sd_qty * item.sd_price, 2);
        } else if (type == '含税单价' || type == '税率') {
          item.sd_price = me.$number.round(item.sd_price || 0, 6);
          item.sd_total = me.$number.round(item.sd_qty * item.sd_price, 2);
          item.sd_netprice = me.$number.round(item.sd_price / (1 + tr / 100), 6);
          item.sd_nettotal = me.$number.round(item.sd_qty * item.sd_netprice, 2);
        }

        item.sd_taxamount = item.sd_total - item.sd_nettotal;
      });
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.sa_custname) {
        me.$weui.topTips("请选择客户", 2000);
      } else if (!main.sa_currency) {
        me.$weui.topTips("请选择币种", 2000);
      } else {
        main.sa_taxrate = main.sa_taxrate || 0;
        var count = 0,
          total = 0,
          nettotal = 0,
          tax = 0;
        items.forEach(function (item) {
          if (!item.sd_prodid) {
            me.$weui.topTips(`第${count + 1}行产品未选择`, 2000);
            return false;
          } else if (!item.sd_qty || item.sd_qty <= 0) {
            me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
            return false;
          } else {
            count++;
            item.sd_detno = count;
            item.sd_taxrate = main.sa_taxrate;
            // 合计
            total += item.sd_total;
            nettotal += item.sd_nettotal;
            tax += item.sd_taxamount;
          }
        });
        checked = count == items.length;
        main.sa_total = total;
        main.sa_nettotal = nettotal;
        main.sa_taxtotal = tax;
      }

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        sd_custprodcode: "",
        sd_qty: 0,
        sd_netprice: 0,
        sd_nettotal: 0,
        sd_price: 0,
        sd_total: 0,
        sd_taxamount: 0,
        sd_delivery: "",
        productDTO: {},
      });
    },
  },
};
</script>